import { getByIdProfileSelector } from '@gymaholic/packages'

export const getCreatorProfileSelect = getByIdProfileSelector(45261)
